import icon1 from '../images/service/1.jpg'
import icon2 from '../images/service/2.jpg'
import icon3 from '../images/service/3.jpg'
import icon4 from '../images/service/4.jpg'


const Services = [
  {
    Id: '01',
    Icon: icon1,
    // SImg: sSimg1,
    title: '',
    Subtitle: '',
    slug: '',
    description:
      '',
  },
  {
    Id: '02',
    Icon: icon2,
    // SImg: sSimg2,
    title: '',
    Subtitle: '',
    slug: '',
    description:
      '',
  },
  {
    Id: '03',
    Icon: icon3,
    // SImg: sSimg3,
    title: '',
    Subtitle: '',
    slug: '',
    description:
      '',
  },
  {
    Id: '04',
    Icon: icon4,
    // SImg: sSimg4,
    title: '',
    Subtitle: '',
    slug: '',
    description:
      '',
  },
  
]

export default Services
